import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map, filter, take } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Auth Guard (Functional Guard)
 * Protects routes by checking authentication status
 * Redirects to Logto login page if not authenticated
 * Stores the attempted URL to redirect back after login
 * Waits for initial auth check to complete before deciding
 */
export const authGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);

    return authService.isAuthenticated$.pipe(
        // Wait for a definitive value (skip the initial subscription)
        filter(value => value !== null && value !== undefined),
        take(1),
        map(isAuthenticated => {
            if (!isAuthenticated) {
                // Store the attempted URL for redirecting after login
                sessionStorage.setItem('returnUrl', state.url);

                // Redirect directly to Logto login page
                authService.signIn();
                return false;
            }
            return true;
        })
    );
};
